<template>
  <div
    class="filters-distribution"
    v-if="currentDistribution[0] >= distributionObj.min && currentDistribution[1] <= distributionObj.max"
  >
    <div class="filters-distribution__title">
      {{ distributionObj.title[$i18n.locale] || distributionObj.title.default }}
      <ui-switch id="distribution-toggle" :value="isActive" :standalone="true" @input="toggle"></ui-switch>
    </div>
    <div
      class="filters-distribution__chart"
      :style="{ gridTemplateColumns: `repeat(${distributionObj.distribution.length}, 1fr)` }"
    >
      <div
        class="filters-distribution__chart__bar"
        :class="{
          'filters-distribution__chart__bar--inactive': inactive(idx),
          'filters-distribution__chart__bar--disabled': !isActive,
        }"
        v-for="(d, idx) in distributionObj.distribution"
        :key="`distribution-${idx}`"
        :style="{ height: `${Math.floor(d * (maxHeight / Math.max(...distributionObj.distribution)))}px` }"
      ></div>
    </div>
    <vue-slider
      class="filters-distribution__slider"
      :value="currentDistribution"
      tooltip="focus"
      :min="distributionObj.min"
      :max="distributionObj.max"
      :clickable="false"
      :dotSize="24"
      :interval="1"
      :enable-cross="false"
      :tooltip-formatter="`{value}`"
      tooltipPlacement="top"
      :rail-style="{
        backgroundColor: '#ddd',
        height: '6px',
      }"
      :dot-style="{
        backgroundColor: '#54cad9',
        border: '2px solid #fff',
        boxShadow: 'none',
      }"
      :process-style="{ backgroundColor: '#54cad9' }"
      :tooltip-style="{
        backgroundColor: '#54cad9',
        borderColor: '#54cad9',
        fontSize: '0.75rem',
        fontWeight: 'bold',
        padding: '4px 8px',
      }"
      :marks="marksDistribution"
      :disabled="!isActive"
      @dragging="update"
      @drag-end="refresh"
    ></vue-slider>
  </div>
</template>

<script>
import VueSlider from 'vue-slider-component'
import UiSwitch from '@/components/UI/Switch.vue'

export default {
  name: 'FilterDistribution',
  components: {
    VueSlider,
    UiSwitch,
  },
  props: {
    distributionObj: {
      type: Object,
      required: true,
    },
    currentDistribution: {
      type: Array,
      required: true,
    },
    isActive: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      maxHeight: 100,
    }
  },
  created() {
    this.marksDistribution = value => {
      if (value === this.distributionObj.min) {
        return {
          label: `${value} ${this.distributionObj.name[this.$i18n.locale] || this.distributionObj.name.default}`,
          labelStyle: {
            fontSize: '0.75rem',
            marginTop: '0',
            padding: '12px 0 0',
          },
        }
      }
      if (value === this.distributionObj.max) {
        return {
          label: `${value} ${this.distributionObj.name[this.$i18n.locale] || this.distributionObj.name.default}`,
          labelStyle: {
            fontSize: '0.75rem',
            marginTop: '0',
            padding: '12px 0 0',
          },
        }
      }
    }
  },
  methods: {
    update(values) {
      this.$emit('update', values)
    },
    refresh() {
      this.$emit('refresh')
    },
    inactive(idx) {
      return (
        idx / this.distributionObj.distribution.length <
          (this.currentDistribution[0] - this.distributionObj.min) /
            (this.distributionObj.max - this.distributionObj.min) ||
        idx / this.distributionObj.distribution.length >
          (this.currentDistribution[1] - this.distributionObj.min) /
            (this.distributionObj.max - this.distributionObj.min)
      )
    },
    toggle(bool) {
      this.$emit('toggle', bool)
    },
  },
}
</script>

<style lang="scss">
.filters-distribution {
  padding-bottom: 20px;

  &__title {
    @include sub-title;

    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &__chart {
    display: grid;
    position: relative;
    margin: auto;
    height: 100%;

    &__bar {
      align-self: end;
      margin: 1px;
      border-radius: 2px 2px 0 0;
      background-color: map-get($generic-color-variants, 'gtr');
      min-height: 2px;

      &--inactive {
        background-color: $generic-color-bg-disabled;
      }

      &--disabled {
        opacity: 0.5;
      }
    }
  }

  &__slider {
    .vue-slider-mark {
      &:first-child .vue-slider-mark-label {
        left: 0;
        transform: translateX(0);
      }

      &:nth-child(2) .vue-slider-mark-label {
        transform: translateX(-100%);
        text-align: right;
      }
    }
  }
}
</style>
